document.addEventListener('alpine:init', () => {
    Alpine.store('header', {
        playerCount: 0,
        budget: 0,
        salaryMass: 0,
        salaryCap: 0,
        mercatoPending: 0,
        mercatoAccepted: 0,
        mercatoQueued: 0,
        mercatoNegotiation: 0,
        mercatoRefused: 0,
        mercatoIncoming: 0,
        // Effectif projeté calculé par le serveur (effectif + toutes les offres en
        // vol, négociations club comprises). Ne JAMAIS le recomposer à partir des
        // compteurs ci-dessus : c'est ce qui faisait diverger les écrans.
        projectedSquad: 0,

        fmt(n) {
            n = Math.round(n);
            if (n >= 1000000) return Math.round(n / 100000) / 10 + 'M';
            if (n >= 10000) return Math.round(n / 1000) + 'k';
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
    });
});

window.sidebarData = function () {
    return {
        activePanel: null,
        userStatus: 'online',
        rankingStatus: (document.querySelector('meta[name="ranking-status"]') || {}).content || 'off',
        coopStatus: (document.querySelector('meta[name="coop-status"]') || {}).content || 'off',
        userName: null,
        statusOpen: false,
        changeStatuTimeout: false,
        unreadUserCount: 0,
        unreadTeamCount: 0,
        unreadSiteCount: 0,
        refreshInterval: null,
        rankingInactivityTimeout: null,
        // Mon match ranking en cours (module ranking OU live LDM/King) : allume
        // l'icône Ranking en rouge et déclenche le popup « Rejoindre le match ».
        rankingActiveMatch: null,
        rankingActiveMatchKey: null,

        // Bids panel
        bidsLoading: false,
        bidsInitialized: false,
        bidsPendingList: [],
        bidsLostList: [],
        bidsSquadList: [],
        bidsTab: 'pending',
        bidsPendingCount: 0,
        bidsCurrentPlayersCount: 0,
        bidsProjectedSquad: 0,
        bidsIsInMercato: false,
        bidsCountInterval: null,
        showStatsModal: false,
        selectedPlayerStats: null,
        statsLoading: false,
        statsError: null,
        showBidsRenewModal: false,
        selectedRenewBid: null,
        renewBidAmount: 0,
        renewSalaryAmount: 0,
        renewDuration: 1,
        renewPlayerRole: 'titulaire',
        renewBidError: '',
        renewBidSubmitting: false,

        get totalUnreadCount() {
            return this.unreadUserCount + this.unreadTeamCount + this.unreadSiteCount;
        },

        init() {
            this.fetchCounts();
            this.loadBidsCount();
            let self = this;
            this.refreshInterval = setInterval(function () {
                self.fetchCounts();
            }, 15000);

            // Le mercato bouge sans nous : le joueur répond, une offre expire, un
            // round part d'un autre écran. Sans ce rappel, le badge et l'« effectif
            // projeté » du tiroir restaient figés sur l'état du chargement de page
            // — un onglet laissé ouvert affichait encore 22 quand la base disait 23.
            this.bidsCountInterval = setInterval(function () {
                if (!document.hidden) {
                    self.loadBidsCount();
                }
            }, 60000);

            document.addEventListener('visibilitychange', function () {
                if (document.hidden) return;
                self.loadBidsCount();
                if (self.activePanel === 'bids') {
                    self.loadBidsData();
                }
            });

            document.addEventListener('click', function (e) {
                if (self.activePanel && !self.showBidsRenewModal && !e.target.closest('.sidebar-container')) {
                    self.activePanel = null;
                }
            });

            window.addEventListener('notification-count-changed', function (e) {
                self.unreadUserCount = e.detail.user;
                self.unreadTeamCount = e.detail.team;
                self.unreadSiteCount = e.detail.site;
            });

            // Popup de connexion « Marquer comme lu » : re-synchronise les compteurs
            // (cloche + badges d'onglets du panneau) depuis le serveur.
            window.addEventListener('notifications-updated', function () {
                self.fetchCounts();
            });

            window.addEventListener('open-bids-panel', function () {
                self.openPanel('bids');
                self.loadBidsData();
            });


            window.addEventListener('ranking-status-changed', function (e) {
                self.rankingStatus = e.detail.status;
                if (e.detail.status === 'on') {
                    self.startRankingInactivityTimer();
                } else {
                    self.stopRankingInactivityTimer();
                }
            });

            // Portée de dispo changée ailleurs (popup d'arrivée sur le Ranking).
            window.addEventListener('ranking-availability-mode-changed', function (e) {
                if (e.detail && e.detail.mode) self.rankingAvailabilityMode = e.detail.mode;
            });

            window.addEventListener('coop-status-changed', function (e) {
                self.coopStatus = e.detail.status;
            });

            if (this.rankingStatus === 'on') {
                this.startRankingInactivityTimer();
            }

            window.addEventListener('sidebar-bids-changed', function () {
                if (self.bidsInitialized) {
                    self.loadBidsData();
                } else {
                    self.loadBidsCount();
                }
            });

            ['mousemove', 'keydown', 'touchstart', 'click'].forEach(function (evt) {
                document.addEventListener(evt, function () {
                    if (self.rankingStatus === 'on') {
                        self.resetRankingInactivityTimer();
                    }
                }, { passive: true });
            });
        },

        startRankingInactivityTimer() {
            this.stopRankingInactivityTimer();
            let self = this;
            this.rankingInactivityTimeout = setTimeout(function () {
                if (self.rankingStatus === 'on') {
                    fetch('/ranking/toggle-status', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    })
                        .then(r => r.json())
                        .then(data => {
                            if (data.success) {
                                self.rankingStatus = data.ranking_status;
                                window.dispatchEvent(new CustomEvent('ranking-status-changed', { detail: { status: data.ranking_status } }));
                            }
                        })
                        .catch(err => console.error('Ranking auto-off error:', err));
                }
            }, 15 * 60 * 1000);
        },

        stopRankingInactivityTimer() {
            if (this.rankingInactivityTimeout) { clearTimeout(this.rankingInactivityTimeout); this.rankingInactivityTimeout = null; }
        },

        resetRankingInactivityTimer() {
            this.startRankingInactivityTimer();
        },

        fetchCounts() {
            let self = this;
            fetch('/notifications', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    self.unreadUserCount = data.unread_user_notification_count || 0;
                    self.unreadTeamCount = data.unread_team_info_count || 0;
                    self.unreadSiteCount = data.unread_site_notification_count || 0;
                    self.userStatus = data.user_status || 'online';
                    let newRankingStatus = data.ranking_status || 'off';
                    if (self.rankingStatus !== newRankingStatus) {
                        self.rankingStatus = newRankingStatus;
                        if (newRankingStatus === 'on') {
                            self.startRankingInactivityTimer();
                        } else {
                            self.stopRankingInactivityTimer();
                        }
                    }
                    self.userName = data.user_name;

                    window.dispatchEvent(new CustomEvent('sidebar-counts-updated', {
                        detail: {
                            user: self.unreadUserCount,
                            team: self.unreadTeamCount,
                            site: self.unreadSiteCount,
                            total: self.totalUnreadCount,
                            master_ranking: data.user_master_ranking
                        }
                    }));

                    if (data.pending_match_invitation) {
                        window.dispatchEvent(new CustomEvent('pending-match-invitation', {
                            detail: data.pending_match_invitation
                        }));
                    }

                    if (data.pending_ranking_invitation) {
                        window.dispatchEvent(new CustomEvent('pending-ranking-invitation', {
                            detail: data.pending_ranking_invitation
                        }));
                    }

                    if (data.active_live_match) {
                        window.dispatchEvent(new CustomEvent('active-live-match-detected', {
                            detail: data.active_live_match
                        }));
                    }

                    // Match ranking en cours : un défi LDM (épées croisées) ou un
                    // match King se joue sur /matches/{id}/live et n'était signalé
                    // nulle part dans le Ranking. Le popup n'est proposé qu'une
                    // fois par match (clé kind+id).
                    self.rankingActiveMatch = data.active_ranking_match || null;
                    let rankingKey = self.rankingActiveMatch
                        ? self.rankingActiveMatch.kind + '-' + self.rankingActiveMatch.id
                        : null;
                    // Rappel permanent dans le panneau ranking (le popup, lui, se ferme).
                    window.dispatchEvent(new CustomEvent('ranking-active-match-state', {
                        detail: self.rankingActiveMatch
                    }));
                    if (rankingKey !== self.rankingActiveMatchKey) {
                        self.rankingActiveMatchKey = rankingKey;
                        if (self.rankingActiveMatch) {
                            window.dispatchEvent(new CustomEvent('ranking-active-match', {
                                detail: self.rankingActiveMatch
                            }));
                        }
                    }
                })
                .catch(err => console.error('Sidebar counts error:', err));
        },

        openPanel(panel) {
            this.activePanel = this.activePanel === panel ? null : panel;
        },

        /**
         * Icône Ranking : ouvre le panneau et, si un match ranking est en cours
         * (défi authentique, défi LDM ou match King), repropose le popup pour le
         * rejoindre — l'icône rouge doit toujours mener quelque part.
         */
        openRankingPanel() {
            this.openPanel('ranking');
            window.dispatchEvent(new Event('ranking-panel-opened'));
            if (this.rankingActiveMatch) {
                window.dispatchEvent(new CustomEvent('ranking-active-match', { detail: this.rankingActiveMatch }));
            }
        },

        closePanel() {
            this.activePanel = null;
        },

        toggleStatus() {
            this.statusOpen = !this.statusOpen;
        },

        changeStatus(event) {
            if (event) event.stopPropagation();
            clearTimeout(this.changeStatuTimeout);

            if (this.userStatus === 'online') this.userStatus = 'ready-to-play';
            else if (this.userStatus === 'ready-to-play') this.userStatus = 'offline';
            else this.userStatus = 'online';

            let self = this;
            this.changeStatuTimeout = setTimeout(function () {
                fetch('/notifications/update-status', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ status: self.userStatus })
                }).catch(err => console.error('Status update error:', err));
            }, 500);
        },

        toggleRankingStatus() {
            let self = this;
            fetch('/ranking/toggle-status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.rankingStatus = data.ranking_status;
                        window.dispatchEvent(new CustomEvent('ranking-status-changed', { detail: { status: data.ranking_status } }));
                        if (data.ranking_status === 'on') {
                            self.openPanel('ranking');
                            window.dispatchEvent(new Event('ranking-panel-opened'));
                            self.startRankingInactivityTimer();
                        } else {
                            self.stopRankingInactivityTimer();
                        }
                        if (data.active_match) {
                            window.dispatchEvent(new CustomEvent('ranking-active-match', { detail: data.active_match }));
                        }
                    }
                })
                .catch(err => console.error('Ranking toggle error:', err));
        },

        // Portée de disponibilité ranking (choix du mode) — affichée dans le
        // statut ranking de la sidebar. Même logique que ranking-panel.js.
        rankingAvailabilityMode: ((document.querySelector('meta[name="ranking-availability-mode"]') || {}).content || 'all'),

        rankingModeLabel() {
            return {
                all: window.trans('sidebar.status.mode_all'),
                authentique: window.trans('sidebar.status.mode_authentic'),
                ldm: window.trans('sidebar.status.mode_ldm'),
                dream_free: window.trans('sidebar.status.mode_dream_free'),
                dream_mois: window.trans('sidebar.status.mode_dream_month'),
                dream_month: window.trans('sidebar.status.mode_dream_month'),
                dream: window.trans('sidebar.status.mode_dream_free')
            }[this.rankingAvailabilityMode] || window.trans('sidebar.status.mode_all');
        },

        cycleRankingMode(dir = 1) {
            let order = ['all', 'authentique', 'ldm', 'dream_free', 'dream_mois'];
            let previous = this.rankingAvailabilityMode;
            let index = order.indexOf(previous);
            if (index === -1) index = 0;
            this.rankingAvailabilityMode = order[(index + dir + order.length) % order.length];
            let self = this;
            fetch('/ranking/availability-mode', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ availability_mode: this.rankingAvailabilityMode })
            })
                .then(r => r.json())
                .then(data => {
                    if (!data.success) {
                        self.rankingAvailabilityMode = previous;
                        if (data.message) alert(data.message);
                    } else {
                        window.dispatchEvent(new CustomEvent('ranking-availability-mode-changed', { detail: { mode: self.rankingAvailabilityMode } }));
                    }
                })
                .catch(err => { self.rankingAvailabilityMode = previous; console.error('availability mode error:', err); });
        },

        /**
         * Étoiles d'ÉQUIPE (niveau), au barème du jeu : piste de 5 slots, jamais plus.
         * La valeur arrive déjà calculée du serveur (App\Support\StarRating appliqué
         * à la note d'effectif) — ne rien recalculer ici. La réputation, elle, se lit
         * en points : elle n'a plus d'étoiles.
         */
        teamStars(stars) {
            if (!stars) return '';
            let full = Math.floor(stars);
            let half = (stars % 1) >= 0.5 ? 1 : 0;
            let empty = 5 - full - half;
            let s = '';
            for (let i = 0; i < full; i++) s += '<i class="material-icons star-full">star</i>';
            if (half) s += '<i class="material-icons star-half">star_half</i>';
            for (let i = 0; i < empty; i++) s += '<i class="material-icons star-empty">star_border</i>';
            return s;
        },

        // Bids panel methods
        // Version légère : compteurs seuls, sans l'effectif ni les listes d'offres.
        async loadBidsCount() {
            try {
                const response = await fetch('/bids/sidebar-data?counts_only=1', {
                    cache: 'no-store',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                const data = await response.json();
                this.applyBidsCounts(data);
            } catch (error) {}
        },

        // Le tiroir se recharge à CHAQUE ouverture : son contenu ne doit jamais
        // dater du chargement de la page. Seule une requête déjà en vol est évitée.
        async initBids() {
            if (this.bidsLoading) return;
            await this.loadBidsData();
            this.bidsInitialized = true;
        },

        async loadBidsData() {
            this.bidsLoading = true;
            try {
                const response = await fetch('/bids/sidebar-data', {
                    cache: 'no-store',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                const data = await response.json();
                this.bidsPendingList = data.pending || [];
                this.bidsLostList = data.lost || [];
                this.bidsSquadList = data.squad || [];
                this.applyBidsCounts(data);
            } catch (error) {
                console.error('Bids data error:', error);
            } finally {
                this.bidsLoading = false;
            }
        },

        // Compteurs du tiroir + en-têtes de page, servis par les deux modes de
        // /bids/sidebar-data (complet et counts_only).
        applyBidsCounts(data) {
            this.bidsPendingCount = data.pending_count || 0;
            this.bidsCurrentPlayersCount = data.current_players_count || 0;
            this.bidsProjectedSquad = data.projected_squad_size || 0;
            this.bidsIsInMercato = data.is_in_mercato || false;
            this.updatePageHeaders(data);
        },

        updatePageHeaders(data) {
            var store = Alpine.store('header');
            if (!store) return;
            if (data.mercato_stats) {
                store.mercatoPending = data.mercato_stats.pending;
                store.mercatoAccepted = data.mercato_stats.accepted || 0;
                store.mercatoQueued = data.mercato_stats.queued;
                store.mercatoNegotiation = data.mercato_stats.negotiation || 0;
                store.mercatoRefused = data.mercato_stats.refused;
                store.mercatoIncoming = data.mercato_stats.incoming;
            }
            if (data.projected_squad_size !== undefined) {
                store.projectedSquad = data.projected_squad_size;
            }
            if (data.header_stats) {
                store.playerCount = data.header_stats.player_count;
                store.budget = data.header_stats.remaining_budget;
                store.salaryMass = data.header_stats.salary_mass;
                store.salaryCap = data.header_stats.salary_cap;
            }
        },

        openStatsModal(apiId, name) {
            this.showStatsModal = true;
            this.selectedPlayerStats = null;
            this.statsError = null;
            this.loadPlayerStats(apiId);
        },

        closeStatsModal() {
            this.showStatsModal = false;
            this.selectedPlayerStats = null;
            this.statsError = null;
        },

        loadPlayerStats(playerId) {
            this.statsLoading = true;
            this.statsError = null;
            fetch('/players/stats/' + playerId, { cache: 'no-store' })
                .then(function (response) {
                    if (!response.ok) throw new Error('Erreur lors du chargement');
                    return response.json();
                })
                .then(function (data) {
                    this.selectedPlayerStats = data.player;
                    this.statsLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.statsError = window.trans('sidebar.bids.error_load_stats');
                    this.statsLoading = false;
                }.bind(this));
        },

        getRatingClass(value) {
            if (!value || value === '-') return '';
            value = parseInt(value);
            if (value >= 85) return 'rating-excellent';
            if (value >= 75) return 'rating-good';
            if (value >= 65) return 'rating-average';
            return 'rating-poor';
        },

        formatBidRole(role) {
            switch (role) {
                case 'cle': case 'key': return window.trans('sidebar.bids.role_badge_key');
                case 'titulaire': case 'starter': return window.trans('sidebar.bids.role_badge_titulaire');
                case 'joker': return window.trans('sidebar.bids.role_badge_joker');
                case 'rotation': return window.trans('sidebar.bids.role_badge_rotation');
                case 'espoir': case 'prospect': return window.trans('sidebar.bids.role_badge_espoir');
                default: return role || '';
            }
        },

        async deleteSidebarPendingBid(bidId) {
            if (!confirm(window.trans('sidebar.bids.confirm_delete_pending'))) return;
            try {
                const response = await fetch(`/bids/${bidId}`, {
                    method: 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });
                const data = await response.json();
                if (data.success) {
                    this.bidsPendingList = this.bidsPendingList.filter(b => b.id !== bidId);
                    this.bidsPendingCount = this.bidsPendingList.length;
                    this.bidsCurrentPlayersCount = data.current_players_count || this.bidsCurrentPlayersCount;
                    await this.loadBidsData();
                    window.dispatchEvent(new CustomEvent('bid-deleted', { detail: data }));
                }
            } catch (error) {
                console.error('Delete pending bid error:', error);
            }
        },

        async confirmSidebarAcceptedBid(bidId) {
            if (!confirm(window.trans('sidebar.bids.confirm_validate_transfer'))) return;
            try {
                const response = await fetch(`/bids/${bidId}/confirm`, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });
                const data = await response.json();
                if (data.success) {
                    this.bidsPendingList = this.bidsPendingList.filter(b => b.id !== bidId);
                    this.bidsPendingCount = this.bidsPendingList.length;
                    await this.loadBidsData();
                    window.dispatchEvent(new CustomEvent('bid-confirmed', { detail: data }));
                } else {
                    alert(data.message || window.trans('sidebar.bids.error_validation'));
                }
            } catch (error) {
                console.error('Confirm accepted bid error:', error);
            }
        },

        async refuseSidebarAcceptedBid(bidId) {
            if (!confirm(window.trans('sidebar.bids.confirm_refuse_offer'))) return;
            try {
                const response = await fetch(`/bids/${bidId}/refuse`, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });
                const data = await response.json();
                if (data.success) {
                    this.bidsPendingList = this.bidsPendingList.filter(b => b.id !== bidId);
                    this.bidsPendingCount = this.bidsPendingList.length;
                    await this.loadBidsData();
                    window.dispatchEvent(new CustomEvent('bid-refused', { detail: data }));
                } else {
                    alert(data.message || window.trans('sidebar.bids.error_refusal'));
                }
            } catch (error) {
                console.error('Refuse accepted bid error:', error);
            }
        },

        // Une offre de prêt ? (prêt inter-équipes, prêt sur liste, prêt d'agent libre)
        isLoanBid(bid) {
            return ['loan', 'loan_list', 'free_loan'].includes(bid && bid.type);
        },

        openBidsRenewModal(bid) {
            this.selectedRenewBid = bid;
            this.renewBidAmount = Math.round(bid.amount || 0);
            this.renewSalaryAmount = parseFloat(bid.salary) > 0 ? Math.round(bid.salary) : this.calculateMinSalary(this.renewBidAmount);
            this.renewDuration = bid.duration || 1;
            this.renewPlayerRole = bid.role || 'titulaire';
            this.renewBidError = '';
            this.renewBidSubmitting = false;
            this.showBidsRenewModal = true;
        },

        closeBidsRenewModal() {
            this.showBidsRenewModal = false;
            this.selectedRenewBid = null;
        },

        calculateMinSalary(amount) {
            let rate = 0.05;
            if (amount >= 200000) rate = 0.3;
            else if (amount >= 100000) rate = 0.25;
            else if (amount >= 80000) rate = 0.2;
            else if (amount >= 50000) rate = 0.15;
            else if (amount >= 20000) rate = 0.1;
            return Math.round(amount * rate);
        },

        updateRenewSalary() {
            const minSalary = this.calculateMinSalary(this.renewBidAmount);
            if (this.renewSalaryAmount < minSalary) {
                this.renewSalaryAmount = minSalary;
            }
        },

        async submitBidsRenewal() {
            const bid = this.selectedRenewBid;
            if (!bid) return;

            const isLoan = this.isLoanBid(bid);

            // Un prêt d'agent libre porte une indemnité nulle : exiger un montant
            // renvoyait « remplir tous les champs » sur un formulaire pourtant complet.
            const amountMissing = isLoan
                ? (this.renewBidAmount === '' || this.renewBidAmount === null || this.renewBidAmount === undefined)
                : !this.renewBidAmount;

            if (amountMissing || !this.renewSalaryAmount || !this.renewPlayerRole) {
                this.renewBidError = window.trans('sidebar.bids.error_fill_fields');
                return;
            }

            if (!isLoan && this.renewBidAmount < bid.player_price) {
                this.renewBidError = window.trans('sidebar.bids.error_amount_too_low');
                return;
            }

            this.renewBidSubmitting = true;
            this.renewBidError = '';

            try {
                const response = await fetch('/bids/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        id: bid.id,
                        player_id: bid.player_api_id,
                        amount: this.renewBidAmount,
                        salary: this.renewSalaryAmount,
                        duration: isLoan ? 1 : this.renewDuration,
                        role: this.renewPlayerRole
                    })
                });
                const data = await response.json();
                this.renewBidSubmitting = false;

                if (data.success) {
                    this.closeBidsRenewModal();
                    this.bidsLostList = this.bidsLostList.filter(b => b.id !== bid.id);
                    this.bidsPendingCount++;
                    await this.loadBidsData();
                    window.dispatchEvent(new CustomEvent('bid-renewed', { detail: data }));
                } else {
                    this.renewBidError = data.error || data.message || window.trans('sidebar.bids.error_send_offer');
                }
            } catch (error) {
                this.renewBidSubmitting = false;
                this.renewBidError = window.trans('sidebar.bids.error_network_retry');
            }
        },

        async deleteSidebarLostBid(bidId) {
            if (!confirm(window.trans('sidebar.bids.confirm_delete_lost'))) return;
            try {
                const response = await fetch(`/bids/${bidId}/delete`, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                });
                const data = await response.json();
                if (data.success) {
                    this.bidsLostList = this.bidsLostList.filter(b => b.id !== bidId);
                    await this.loadBidsData();
                }
            } catch (error) {
                console.error('Delete lost bid error:', error);
            }
        },

        formatBidPrice(amount) {
            if (!amount) return '0';
            if (amount >= 1000000) return (amount / 1000000).toFixed(1).replace('.0', '') + 'M';
            if (amount >= 1000) return (amount / 1000).toFixed(0) + 'K';
            return amount.toString();
        }
    };
};
